const stripInlineStyles = (container) => {
  container.querySelectorAll('span[style]').forEach((el) => {
    el.removeAttribute('style');
  });
};

// Remove FA's injected theme stylesheet and watch for form injection
const headObserver = new MutationObserver((mutations) => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach((node) => {
      if (node.tagName === 'LINK' && node.href?.includes('tfaforms.net')) {
        node.remove();
      }
    });
  });
});

headObserver.observe(document.head, { childList: true });

const initPageIndicator = (container) => {
  const tabNav = container.querySelector('#wfTabNav');
  if (!tabNav || tabNav.dataset.indicatorInit) return;
  tabNav.dataset.indicatorInit = '1';
  tabNav.hidden = true;

  // Remove any stale indicators left over from previous page loads
  container.querySelectorAll('.fa-page-indicator').forEach((el) => el.remove());

  const indicator = document.createElement('p');
  indicator.className = 'fa-page-indicator';
  indicator.setAttribute('aria-live', 'polite');
  indicator.setAttribute('aria-atomic', 'true');
  tabNav.insertAdjacentElement('afterend', indicator);

  const update = () => {
    const tabs = tabNav.querySelectorAll('.wfTab');
    const current = tabNav.querySelector('.wfTabCurrentPage');
    if (!tabs.length || !current) return;
    indicator.textContent = `Step ${Array.from(tabs).indexOf(current) + 1} of ${tabs.length}`;
  };

  update();
  new MutationObserver(update).observe(tabNav, { subtree: true, attributeFilter: ['class'] });
};

// Show/hide toggle button
document.querySelectorAll('[data-form-toggle]').forEach((btn) => {
  const target = document.getElementById(btn.getAttribute('aria-controls'));
  if (!target) return;
  btn.addEventListener('click', () => {
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!isExpanded));
    target.hidden = isExpanded;
    btn.textContent = isExpanded ? btn.dataset.openText : btn.dataset.hideText;
  });
});

// Watch each FA container and strip inline styles once FA injects the form HTML
document.querySelectorAll('.fa-js-embed').forEach((container) => {
  const formObserver = new MutationObserver(() => {
    stripInlineStyles(container);
    initPageIndicator(container);
  });
  formObserver.observe(container, { childList: true, subtree: true });
});
